import React from "react";
import styled from "@emotion/styled/macro";
import {
    Grid2 as Grid,
    Button,
    Tooltip,
    Fade
} from '@mui/material';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import NotFoundHere from './assets/not_found_here.png';

const StyledGridContainer = styled(Grid)`
    height: 100%;
    align-items: center;
    font-family: poppins;
    width: 100%;
    margin-top: 2vh;
`;
const StyledNotFoundHereButton = styled(Button)`
    height: 80vh;
    width: 100%;
`;
const StyledNotFoundHereImage = styled.img`
    height: 100%;
    width: 100%;
`;

const NotFound = () => {
    let history = useHistory();

    const handleImageClick = () => {
        history.goBack();
    };

    return ( 
        <StyledGridContainer container>
            <Grid item size={{xs:12, sm:12, md: 12}}>
                <Tooltip title="Click to return from whence you came" followCursor placement="right-start">
                    <Fade in mountOnEnter unmountOnExit timeout={400}>
                        <StyledNotFoundHereButton onClick={handleImageClick}>
                            <StyledNotFoundHereImage src={NotFoundHere} alt="picture depicting a desert in the middle of nowhere with a sign stating not found here"/>
                        </StyledNotFoundHereButton>
                    </Fade>
                </Tooltip>
            </Grid>
        </StyledGridContainer>
    );
}
 
export default NotFound;